import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const StyledSummary = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
  paddingBottom: theme.spacing(6),

  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(8),
  },
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  '&:not(:last-child)': {
    borderRight: 'none',
    [theme.breakpoints.up('sm')]: {
      borderRight: '2px solid',
      borderColor: theme.palette.common.white,
    },
  },
}));

const Item = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,

  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 110,
  padding: theme.spacing(4),
}));

const Value = styled('div')(({ theme }) => ({
  fontSize: 32,
  fontWeight: 500,
  marginBottom: theme.spacing(1),
  color: theme.palette.common.white,
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  textTransform: 'none',
  color: theme.palette.common.white,
}));

type Props = {
  items: {
    text: string | number | React.ReactNode;
    header: string | React.ReactNode;
  }[];
};

const Summary: React.FC<Props> = ({ items }) => {
  return (
    <StyledSummary container spacing={4} direction="row" justifyContent="center" alignItems="stretch">
      {items.map((item, idx) => (
        <StyledGrid key={idx} size={{ xs: 6, sm: 3 }}>
          <Item>
            <Value>{item.header}</Value>
            <StyledTypography variant="caption">{item.text}</StyledTypography>
          </Item>
        </StyledGrid>
      ))}
    </StyledSummary>
  );
};

export default React.memo(Summary);
